function submitNotifierForm(modal){
	$('.popupCnt').on('submit', '.createEditFormNotify', function(e){
		e.preventDefault();
		var thisEl = $(this);
		var href = thisEl.attr('action');
		
		if(href){
			// get all form field values
			var formdata = new FormData(thisEl[0]);
			
			// post formdata to server
			axios.post(href, formdata)
				.then(function (response) {
					refreshPageData();
					modal.close();
				})
				.catch(function (error) {
					if(error.response && (error.response.status === 401 || error.response.status === 419)){
						window.location.href = "/login";
					}
				});
		}
	});
}




$('body').on('click', '.addNotifierBtn', function(e){
	e.preventDefault();
	
	var href = $(this).attr('href');
	var title = $(this).attr('title');
	var addModal;

	axios.get(href)
		.then(function (respons) {				
			addModal = new window.Popup(title, respons.data);
			addModal.open();
			
			formMagic();
			submitNotifierForm(addModal);
		})
		.catch(error => {
			if(error.response && (error.response.status === 401 || error.response.status === 419)){
				window.location.href = "/login";
			}
		});
});


$('body').on('click', '.editNotifierBtn', function(e){
	e.preventDefault();
	
	var href = $(this).attr('href');
	var title = $(this).attr('title');
	var returnUrl = $(this).attr('data-return');
	var editModal;
		
	axios.get(href)
		.then(function (respons) {
			var rethtml = respons.data;
			if(returnUrl){
				rethtml = $(respons.data).attr('data-return', returnUrl).wrap('<p>').parent().html();
			}
			editModal = new window.Popup(title, rethtml);
			editModal.open();
			
			formMagic();
			submitNotifierForm(editModal);
		})
		.catch(error => {
			if(error.response && (error.response.status === 401 || error.response.status === 419)){
				window.location.href = "/login";
			}
		});
		
	return false;
});

$('body').on('click', '.delNotifierBtn', function(e){
	e.preventDefault();
	
	var href 	 = $(this).attr('href');
	var par 	 = $(this).parents('.notifierHld');
	var formdata = new FormData();
	formdata.append('_method', 'DELETE');
	
	axios.post(href, formdata)
		.then(function (response) {
			par.remove();
		})
		.catch(function (error) {
			if(error.response && (error.response.status === 401 || error.response.status === 419)){
				window.location.href = "/login";
			}
		});
});